$(() => {
  $("p.js-profile--readmore").readmore({
    speed: 75,
    moreLink: '<a href="#">...もっと見る</a>',
    lessLink: '<a href="#">...折りたたむ</a>',
  });
});
